export default __webpack_public_path__ + "static/media/rocket.8eb3c7bb.svg";